import { DocumentTypeEnum } from 'app/models';

export const documentTypeMap: Record<string, DocumentTypeEnum | undefined> = {
	ownerPage: DocumentTypeEnum.StsOwnerPage,
	mainPage: DocumentTypeEnum.StsMainPage,
};

export const documentLocalizedLabelMap: Record<string, string> = {
	ownerPage: 'transports-certificate-owner-page',
	mainPage: 'transports-certificate-main-page',
};
